import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

const CheckboxIcon = (props: IconWrapperProps) => (
  <IconWrapper
    width="24"
    height="24"
    viewBox="0 0 24 24"
    title="Checkbox"
    {...props}
  >
    <rect
      x="1"
      y="1"
      width="22"
      height="22"
      fill="white"
      stroke="#727170"
      strokeWidth="2"
    />
  </IconWrapper>
);

export default CheckboxIcon;
